 import React, {  Component } from 'react';
 import { connect } from 'react-redux';
 import { Link, browserHistory } from 'react-router';
 import DatePicker from 'react-datepicker';
 import 'react-datepicker/dist/react-datepicker.css';
 import moment from 'moment';
 import _ from 'lodash';
 import {
    createPriceSheet,editPriceSheet
 } from '../../../../redux/actions';
 
 class CreateEditPriceSheetAdmin extends Component {
    constructor(props) {
         super(props);
         this.state = {
            confirmationMessage: '',
            errorMessage: '',
            priceSheetPayload: {
                params: {
                    priceSheet_id: "",
                    accountNumber:  this.props.state.user.selectedAccount.ACCOUNTNUMBER,
                },
                errors: {
                    template_nameError: '',
                    effective_dateError: ''
                }
            },
            minDate: moment(),
            effective_date: null,
            last_update_date: null,
            whichOperation: ''
         }
     }
 
    componentWillMount() {
        const self = this,
            {editPriceSheet } = self.props.state.homepage;
        const whichOperation = self.props.params.whichOperation;
        self.setState({
            whichOperation: whichOperation
        })
        if((whichOperation === 'edit' && !editPriceSheet)) {
            browserHistory.push('/siteManagement/manageAssets');
        } else if(whichOperation === 'edit') {
            self.setState({
                whichOperation,
                priceSheetPayload: {
                    ...self.state.priceSheetPayload,
                    params: JSON.parse(JSON.stringify(editPriceSheet)),
                },
                effective_date: moment(editPriceSheet.effective_date),
                last_update_date: editPriceSheet.last_update_date != null ? moment(editPriceSheet.last_update_date) : '',
            });
        }
    }
    
    updateParams(formName, event) {
        const self = this;
        const name = event.target.name;
        const value = event.target.value;
        if (value.length > 100) {
            self.setState({
                [formName]: {
                    ...self.state[formName],
                    errors: {
                        ...self.state[formName].errors,
                        [name + 'Error']: 'error'
                    }
                }
            });
            return; // Exit the function if validation fails
        }
        self.setState({
            [formName]: {
                ...self.state[formName],
                params: {
                    ...self.state[formName].params,
                    [name]: value
                },
                errors: {
                    ...self.state[formName].errors,
                    [name + 'Error']: '' // Clear the error
                }
            }
        }, () => {
            if (self.state[formName].errors[name + 'Error']) {
                self.setState({
                    [formName]: {
                        ...self.state[formName],
                        errors: {
                            ...self.state[formName].errors,
                            [name + 'Error']: ''
                        },
                    },
                });
            }
        });
    }
 
    // event for close dialog
    handleDialog(dialog, flag, event) {
        event && event.preventDefault();
        this.setState({
            ['show'+dialog]: false
        }, () => {
            this.setState({
                ['show'+dialog]: flag
            })
        })
    }
 
    handleSubmit(event) {
        const self = this;
        const { params, errors } = self.state.priceSheetPayload;
        let formError = false;
        //Reset all errors
        for(var key in errors) {
             if(!params[key.replace("Error","")]) {
                 errors[key] = 'error';
                 formError = true;
             } else {
                errors[key] = '';
            }
         }
        self.setState({
            params,
            errors,
            serviceCallCompleted: false
        }, () => {
            if(!formError) {
                const payload = JSON.parse(JSON.stringify(self.state.priceSheetPayload.params));
                if(self.state.whichOperation === 'create') {
                    self.props.createPriceSheet(payload, '', response => {
                        if(response.status && response.responseObject) {
                            self.setState({
                                serviceCallCompleted: true
                            });
                        } else {
                            browserHistory.push('/error');
                        }
                    });
                } else if(self.state.whichOperation === 'edit') {
                    self.props.editPriceSheet(payload, '', response => {
                    if(response.status && response.responseObject) {
                            self.setState({
                                serviceCallCompleted: true
                            });
                        } else {
                            browserHistory.push('/error');
                        }
                    });
                 }
            }
        });
    }
 
    handleChangeEffectiveDate(date) {
        const self = this;
        self.setState({
            effective_date: date,
              priceSheetPayload: {
                ...self.state.priceSheetPayload,
                params: {
                    ...self.state.priceSheetPayload.params,
                    effective_date: date && date.format('YYYY-MM-DD')
                },
                errors: {
                    ...self.state.priceSheetPayload.errors,
                    effective_dateError: ""
                }
            }
        });
    }

    handleChangeLastUpdateDate(date) {
        const self = this;
        self.setState({
            last_update_date: date,
              priceSheetPayload: {
                ...self.state.priceSheetPayload,
                params: {
                    ...self.state.priceSheetPayload.params,
                    last_update_date: date && date.format('YYYY-MM-DD')
                },
            }
        });
    }
 
     render() {
        const self = this;
        const { priceSheetPayload: { params, errors } } = self.state;
         return (
             <div>
                <div className="push">
                    <h1 className="pageTitle">PRICE SHEET TEMPLATE UPDATE</h1>
                </div>
                {this.state.errorMessage?<p className="red bold push">{this.state.errorMessage}</p>:null}
                {this.state.confirmationMessage?<p className="bold push">{this.state.confirmationMessage}</p>:null}
                {this.state.serviceCallCompleted && <div>
                     {this.state.whichOperation === 'create' && <p className="bold red">Price Sheet has been created successfully.</p>}
                     {this.state.whichOperation === 'edit' && <p className="bold red">Price Sheet has been updated successfully.</p>}
                </div>}
                {errors.template_nameError =="error" && <p className="bold red">Message limit exceeds 100 characters.</p>}
                <div className="largePush">
                    <p className="bold red" id="errorMessage">{this.state.errorMessage}</p>
                    <table style={{width: '100%'}} className="formTableTypeA createOrderTableA">
                        <tbody>
                            <tr>
                                <td className="first-column">Template Name</td>
                                <td className="middle-column">
                                    <textarea  disabled={this.state.serviceCallCompleted}  className={errors.template_nameError} style={{ width: "30rem", height: "3rem", borderRadius: "1rem", resize: "none", padding:"10px" }}
                                        defaultValue={params.template_name}  name="template_name"  onChange={this.updateParams.bind(this, 'priceSheetPayload')}/>
                                </td>
                            </tr>
                            <tr>
                                <td className="first-column">Price Effective Date</td>
                                <td className="middle-column">
                                    <div className={errors.effective_dateError}>
                                        <DatePicker disabled={this.state.serviceCallCompleted} id="effective_date" dateFormat="YYYY-MM-DD" placeholderText="Click to select a date" selected={self.state.effective_date} onChange={this.handleChangeEffectiveDate.bind(this)} />&nbsp;<var>(yyyy-mm-dd)</var>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="first-column">Last Update Date</td>
                                <td className="middle-column">
                                    <div>
                                        <DatePicker disabled={this.state.serviceCallCompleted} id="last_update_date" dateFormat="YYYY-MM-DD" placeholderText="Click to select a date" selected={self.state.last_update_date} onChange={this.handleChangeLastUpdateDate.bind(this)} />&nbsp;<var>(yyyy-mm-dd)</var>
                                    </div>
                                </td>
                            </tr>
                            {!this.state.serviceCallCompleted && <tr>
                                <td />
                                <td className="middle-column">
                                    <input type="button" onClick={this.handleSubmit.bind(this)} className="blueButton uppercase" defaultValue="Submit" />
                                </td>
                            </tr>}
                        </tbody>
                    </table>
                    {this.state.serviceCallCompleted && <div>
                        <p><Link to={"/siteManagement/priceSheetAdmin"}>Return to Previous Screen</Link></p>
                        <div className="clear" />
                    </div>}
                    <p>
                        <Link to="/siteManagement">Back to Site Management</Link>
                    </p>
                </div>
             </div>
         );
     }
 }
 
 const mapStateToProps = (state) => {
    return {state};
 };
 
 const mapDispatchToProps = (dispatch) => ({
    createPriceSheet: (payload, hybridQueryParams, callback) => dispatch(createPriceSheet(payload, hybridQueryParams, callback)),
    editPriceSheet: (payload, hybridQueryParams, callback) => dispatch(editPriceSheet(payload, hybridQueryParams, callback)),
 });
 
 CreateEditPriceSheetAdmin = connect(mapStateToProps, mapDispatchToProps)(CreateEditPriceSheetAdmin);
 export default CreateEditPriceSheetAdmin;
 


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/PriceSheetAdmin/createEditPriceSheetAdmin.js